import {v$,listen,checkIos} from "./helpers";

const isIos = checkIos();
let tipSpans  = v$('.tip > span');

const showTipDiv = e => {
    let tipDiv = e.target.nextElementSibling;
    tipDiv.classList.add('tip_show');
};
const hideTipDiv = () => {
    let tipDiv = v$('.tip_show')[0];
    tipDiv && tipDiv.classList.remove('tip_show');
}

if(isIos){
    listen(tipSpans,'click',showTipDiv);
    window.addEventListener('touchstart',e => {
        if(e.target.parentNode.className !== 'tip' || e.target.className !== 'tip'){
            hideTipDiv();
        }
    })
}else{
    listen(tipSpans,'mouseenter',showTipDiv);
    listen(tipSpans,'mouseleave',hideTipDiv);
}